'use client';

import { css } from '@repo/pandacss/styled-system/css';
import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';
import { useRef } from 'react';
import { DesktopFiltersWithGeo } from './DesktopFilterBar/DesktopFiltersWithGeo';
import { MobileFilters } from './MobileFilters';
import { MobileFiltersWithGeo } from './MobileFilters/MobileFiltersWithGeo';

export type OffersFilterProps = {
  slug: string;
  initialLocation?: StateAbbreviation;
  regionCode?: StateAbbreviation;
  analyticsProps: { actionSection: string; pageIdentifier: string };
  onClearFilters?: () => void;
  initialClientRegion?: string;
  setRegionCode?: (code: StateAbbreviation) => void;
  showFilterSkeleton?: boolean;
  mainSectionRef?: React.RefObject<HTMLDivElement | null>;
};

const wrapperClass = css({
  marginInlineStart: 'auto',
  marginInlineEnd: 'auto',
  maxWidth: { md: '[82%]' },
});

export function OffersFilter({
  slug,
  initialLocation,
  regionCode,
  analyticsProps,
  onClearFilters,
  initialClientRegion,
  showFilterSkeleton,
  mainSectionRef: externalMainSectionRef,
}: OffersFilterProps) {
  const internalRef = useRef<HTMLDivElement>(null);
  const mainSectionRef = externalMainSectionRef ?? internalRef;

  return (
    <div id="offers-filter" className={wrapperClass}>
      <DesktopFiltersWithGeo
        slug={slug}
        initialLocation={initialLocation}
        regionCode={regionCode}
        analyticsProps={analyticsProps}
        onClearFilters={onClearFilters}
        initialClientRegion={initialClientRegion}
        showFilterSkeleton={showFilterSkeleton}
        mainSectionRef={mainSectionRef}
      />
      {initialLocation ? (
        <MobileFiltersWithGeo
          slug={slug}
          analyticsProps={analyticsProps}
          initialLocation={initialLocation}
        />
      ) : (
        <MobileFilters
          slug={slug}
          initialLocation={initialLocation}
          analyticsProps={analyticsProps}
          initialClientRegion={initialClientRegion}
          regionCode={regionCode}
        />
      )}
    </div>
  );
}
